import axios from "axios";
import { OFilters } from "../../redux/state/ordersState";
import { orderFields } from "../../util/orders/orderFields";

export const initialFilter = {
    orderNo: "",
    orderStatus: [],
    paymentStatus: [],
    accountName: "",
    mainSearch: "",
    orderIdentity: "",
    account_id: "",
    contact_id: "",
    source: "cp",
    cp_user_id: '',
    customFilter:''
};

export const fetchOrders = (limit: number = 50, offset: number = 0, order: string = "", orient: string = "asc", filters: OFilters = initialFilter) => {
    const limitParam = limit !== 0 ? `limit=${limit}&`: ``;
    let url = `/api/v1/orders?${limitParam}&offset=${offset}&order=${order}&orient=${orient}&termIn[orderType][]=Order&termIn[orderType][]=CreditMemo&termIn[orderType][]=StoreOrder`;
    for (let key in filters) {
        if (key == "mainSearch") {
            continue;
        }
        if (filters["mainSearch"] == "" && filters[key].length && filters[key] && !Array.isArray(filters[key]) && (key !== 'contact_id') && key !== 'account_id' && key !== 'source' && key !== 'cp_user_id' && key !== 'customFilter') {
            url += `&termIn[${key}]=${filters[key]}`;
        } else if (filters[key].length && Array.isArray(filters[key])) {
            filters[key].forEach(el => {
                url += `&termIn[${key}][]=${el}`
            });
        } else if (filters[key].length && !Array.isArray(filters[key]) && (key === 'contact_id' || key === 'account_id' || key === 'source' || key === 'cp_user_id' || key === 'customFilter')) {
            url += `&${key}=${filters[key]}`;
        }
    }
    if (filters["mainSearch"] != "") {
        url += `&search=${filters["mainSearch"]}`;
    }
    return axios.get(url);
}

export const fetchOrderStatuses = () => axios.post('/content/get-statuses', { module: 'Order' });
export const fetchCurrencyExchangeRates = () => axios.post('/content/get-exchange-rate-list', { "offset": 0, "order": "dateCreated", "orient": "desc", "term": {} });

export const getDocuments = (refId: string[]) =>
    axios.post("/content/get-documents-reference-list", {
        termIn: {
            refId
        },
        term: {},
        offset: 0,
        order: "dateCreated",
        orient: "asc",
    });
export const makePayment = (data) => axios.post('/content/do-batch-payment', data);
export const cloneOrder = (data) => axios.post('/api/v1/orders/clone', data);
export const cloneOrdertoQuote = (data) => axios.post('/api/v1/orders/clone-to-quote', data);
export const getOrderTotal = (orderId, payType) => axios.get(`/payments/get-order-total?oId=${orderId}&payBy=${payType}`);
export const getconvenienceFeestatus = (data) => axios.post('/content/get-advance-system-config', data);
export const getOrderDetail = (orderId) => axios.get(`/api/v1/orders/${orderId}?source=cp`);
// No hand-rolled refresh here. The request interceptor already refreshes an
// expired session once, shared across concurrent requests, and stamps the new
// bearer on the outgoing request. The previous version refreshed a second time
// on its own, read the response without extractRefreshToken() — so the
// `{data:{token}}` shape produced `Bearer [object Object]` — and wrote that
// straight onto the global axios default header, where it would break every
// later request rather than just this one.
export const getOrderPayments = (orderId) => axios.post(`/content/get-payment-track`, { oId: orderId });